<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import { useNewAirRoadViewStore } from '@/stores/useNewAirRoadViewStore';
import * as airRoadConstants from '@/constants/airRoad';

export interface Props {
  bookingStep?: airRoadConstants.BookingStep;
}
const props = withDefaults(defineProps<Props>(), {
  bookingStep: airRoadConstants.bookingStepValues.LEG_CHOOSE,
});

const newAirRoadViewStore = useNewAirRoadViewStore();
</script>

<template>
  <menu
    :class="$style.newAirRoadFooterMenuList"
    data-testid="newAirRoadFooterMenuList"
  >
    <li class="d-inline">
      <KBtn
        class="mr-4"
        size="lg"
        variant="outlined"
        :append-icon="airRoadConstants.stepSettings[props.bookingStep].prevIcon"
        :disabled="
          newAirRoadViewStore.bookingStep ===
            airRoadConstants.bookingStepValues.LEG_CHOOSE ||
          newAirRoadViewStore.data.isFetchingAirRoadJobCreateData
        "
        @click="newAirRoadViewStore.handlePrevStepClick"
      >
        {{ airRoadConstants.stepSettings[props.bookingStep].prevText }}
      </KBtn>
    </li>
    <li class="d-inline">
      <KBtn
        size="lg"
        :append-icon="airRoadConstants.stepSettings[props.bookingStep].nextIcon"
        :disabled="
          newAirRoadViewStore.bookingStepValidationState[props.bookingStep] ===
          false
        "
        :loading="newAirRoadViewStore.data.isFetchingAirRoadJobCreateData"
        @click="newAirRoadViewStore.handleNextStepClick"
      >
        {{ airRoadConstants.stepSettings[props.bookingStep].nextText }}
      </KBtn>
    </li>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadFooterMenuList {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
